'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Steps = require('./Steps');

var _Steps2 = _interopRequireDefault(_Steps);

var _Step = require('./Step');

var _Step2 = _interopRequireDefault(_Step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Steps2["default"].Step = _Step2["default"];
exports["default"] = _Steps2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-steps/lib/index.js
// module id = 1535
// module chunks = 0